module.exports = __webpack_public_path__ + "static/For_Your_Assurance-e1bacf47a88dcebd7fb6719e42ab4a15.png";